import React, { useCallback, useEffect, useState } from "react";

import { getUserSettings, updateUserSetting } from "services";

import { useCancelAsyncOnUnmount, useToggleNavs, useTranslation, useUserContext } from "utils";

import { Col, Link, MainPage, NavigationHeader, Row, Switch, Typography } from "components";

export const ProfilePrivacy = () => {
  const { t } = useTranslation(["user", "meta"]);
  const { user } = useUserContext();
  useToggleNavs(!!user, false);

  const [shareData, setShareData] = useState(false);
  const [allowImpersonation, setAllowImpersonation] = useState(true);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  const handleSwitch = () => {
    setShareData(!shareData);
    updateUserSetting({
      item: "dataShare",
      value: !shareData,
    });
  };

  const handleToggleSupportAccess = () => {
    setAllowImpersonation(!allowImpersonation);
    updateUserSetting({
      item: "allowImpersonation",
      value: !allowImpersonation,
    });
  };

  const loadUserSettings = useCallback(() => {
    setLoading(true);

    getUserSettings({
      signal,
    })
      .then((res) => {
        setShareData(res.dataShare);
        setAllowImpersonation(res.allowImpersonation !== false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadUserSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"profile"} containerClass="tiny">
      <NavigationHeader title={t("privacySettings.headerTitle")} />
      <Row>
        <Col>
          <Typography variant="h1">{t("privacySettings.headline")}</Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <Typography variant="paragraph-m">{t("privacySettings.description")}</Typography>
        </Col>
      </Row>
      <Row className="margin-top-400">
        <Col>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="paragraph-m">{t("privacySettings.supportAccess.title")}</Typography>{" "}
            <Switch className={allowImpersonation ? "active" : "inactive"} checked={allowImpersonation} onClick={handleToggleSupportAccess} />
          </div>
          <Typography variant="paragraph-m" className="margin-top-200">
            {t("privacySettings.supportAccess.description")}
          </Typography>
        </Col>
      </Row>
      <Row className="margin-top-400">
        <Col>
          <Typography variant="h2">{t("privacySettings.shareProgress.headline")}</Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <Typography variant="paragraph-m" className="margin-top-200">
            {t("privacySettings.shareProgress.description.hp")}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <Link to="/privacy-policy" target="_blank" mixpanelText={t("privacySettings.shareProgress.readMore")}>
            {t("privacySettings.shareProgress.readMore")}
          </Link>
        </Col>
      </Row>
      <Row className="margin-top-400">
        <Col>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="paragraph-m">{t("privacySettings.shareProgress.agree")}</Typography>{" "}
            <Switch className={shareData ? "active" : "inactive"} checked={shareData} onClick={(v) => handleSwitch(v)} />
          </div>
        </Col>
      </Row>
    </MainPage>
  );
};
